export default __webpack_public_path__ + "static/media/Owestry Low Back Disability Questionnaire.e41ca76f.pdf";